import React, { useState } from "react";

const data = [
  {
    title: "Proposez-vous des services aux particuliers et aux entreprises ?",
    description:
      "Oui, ORTÉGA accompagne aussi bien les entreprises, les structures de santé que les utilisateurs particuliers, en fournissant, installant et maintenant des équipements biomédicaux, informatiques et de bureau."
  },
  {
    title: "Quels types d’équipements fournissez-vous ?",
    description:
      "Nous proposons des équipements biomédicaux, informatiques, téléphonie, serveurs, routeurs, switchs, points d’accès, ainsi que du mobilier de bureau ergonomique et des fournitures professionnelles."
  },
  {
    title: "Est-il possible de faire installer et maintenir les équipements par vos équipes ?",
    description:
      "Absolument. ORTÉGA assure l’installation, la configuration et la maintenance préventive ou corrective de tous vos équipements, pour garantir leur performance et leur durabilité."
  },
  {
    title: "Proposez-vous des logiciels personnalisés ?",
    description:
      "Oui, nous développons des logiciels sur mesure pour optimiser la gestion, la productivité et les processus métiers, adaptés aux besoins des entreprises et professionnels de santé."
  },
  {
    title: "Puis-je recevoir des conseils avant d’acheter un équipement ?",
    description:
      "Oui, notre équipe de support et commerciale est disponible pour vous conseiller sur le choix des équipements et solutions adaptés à vos besoins et votre budget."
  },
  {
    title: "Comment suivre vos actualités et nouveautés ?",
    description:
      "Toutes nos actualités, nouveautés produits et offres sont publiées sur notre site web et nos réseaux sociaux officiels. Vous pouvez également vous inscrire à notre newsletter pour rester informé."
  }
];


export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (

      <div className="row g-4">
        {data.map((item, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-4">
            <FAQItem
              title={item.title}
              desc={item.description}
              open={openIndex === index}
              onClick={() => toggle(index)}
            />
          </div>
        ))}
      </div>

  );
}

function FAQItem({ title, desc, open, onClick }) {
  return (
    <div className={`faq-box p-4 ${open ? "active" : ""}`}>
      <div className="d-flex justify-content-between align-items-start">
        <h5 className="fw-semibold">{title}</h5>

        <button className="btn btn-sm d-flex align-items-center btn-light faq-btn" onClick={onClick}>
          <i className={`bi ${open ? "bi-dash" : "bi-plus"} fs-4`}></i>
        </button>
      </div>

      <div className={`faq-desc text-secondary mt-3 ${open ? "open" : ""}`}>
        {desc}
      </div>
    </div>
  );
}
